import { shallowEqual, useSelector } from 'react-redux';
import { getParticipateSettings } from 'core/AppShell/selectors';
import { IStore } from 'store/interface';
import { IGame } from 'core/AppShell';
import { ParticipateModule } from 'core/interfaces';

export const useParticipateSettings = (module: ParticipateModule) => ({
  settings: useSelector<IStore, IGame>(getParticipateSettings(module), shallowEqual),
});
